import { useContext } from 'react';
import { AppContext } from '../AppProvider';

const useAuthentication = () => {
    const {signIn, signOut, deleteAccount, signInBySubscription} = useContext(AppContext);

    return {signIn, signOut, deleteAccount, signInBySubscription};
};

export {
    useAuthentication
}
